/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_Custom_DiscountInputs */

const en_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom discount`)
};

const de_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierter Rabatt`)
};

const es_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuento personalizado`)
};

const fr_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remise personnalisée`)
};

const nl_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepaste korting`)
};

const it_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizza sconto`)
};

const pt_br2_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconto personalizado`)
};

const pl_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niestandardowa zniżka`)
};

const hu_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéni kedvezmény`)
};

const ro_admin_plan_discount_form_custom_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Custom_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reducere personalizata`)
};

/**
* | output |
* | --- |
* | "Custom discount" |
*
* @param {Admin_Plan_Discount_Form_Custom_DiscountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_custom_discount = /** @type {((inputs?: Admin_Plan_Discount_Form_Custom_DiscountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_Custom_DiscountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "de") return de_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "es") return es_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "nl") return nl_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "it") return it_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_custom_discount(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_custom_discount(inputs)
	return ro_admin_plan_discount_form_custom_discount(inputs)
});
export { admin_plan_discount_form_custom_discount as "admin.plan_discount_form.custom_discount" }